/**
 * Recharts prop presets — spread these instead of retyping axis, grid and
 * cursor config at every call site. Changing a chart convention should be one
 * edit here, not 40 across the app.
 */
import { CHROME, PRIMARY, PRIMARY_ACCENT } from './palette';

/** Horizontal rules only. Vertical grid lines add noise without information. */
export const GRID = {
  strokeDasharray: '3 3',
  vertical: false,
  stroke: CHROME.grid,
  opacity: 0.7,
} as const;

/** Both axes: recessive ink, no tick marks, no axis line. */
export const AXIS = {
  tickLine: false,
  axisLine: false,
  tick: { fontSize: 11, fill: CHROME.axis },
} as const;

/** Use only where a visible baseline genuinely helps read the bars. */
export const AXIS_WITH_LINE = {
  ...AXIS,
  axisLine: { stroke: CHROME.grid },
} as const;

/** Crosshair for line and area charts. */
export const HOVER_LINE = {
  stroke: CHROME.cursor,
  strokeWidth: 1,
  strokeDasharray: '4 2',
} as const;

/** Hover band for bar charts. */
export const HOVER_BAND = { fill: CHROME.grid } as const;

/** Rounded data end, baseline end square. */
export const BAR_RADIUS: [number, number, number, number] = [4, 4, 0, 0];

/** 2px surface gap between adjacent stacked segments. */
export const STACK_GAP = { stroke: 'var(--ds-surface-white)', strokeWidth: 2 } as const;

export const ACTIVE_DOT = {
  r: 4,
  fill: PRIMARY,
  stroke: PRIMARY_ACCENT,
  strokeWidth: 2,
} as const;

export const LINE = { strokeWidth: 2, dot: false } as const;

export const MARGIN = { top: 8, right: 8, bottom: 0, left: 0 } as const;
